module.exports = __webpack_public_path__ + "static/media/boeing.edf3aee4.png";